module.exports = __webpack_public_path__ + "static/exterior-1-db2406b30f7b61f39de345c6e4843e65.jpg";